// extracted by mini-css-extract-plugin
export default {"Loading":"Preloader_Loading__otyuD","circle":"Preloader_circle__W+z+B","spinner-border":"Preloader_spinner-border__KCkNj","spin":"Preloader_spin__U8VvQ"};